import {Layout, Divider, Image, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Siete = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '0vh'}}>Antibodies vs aptamers</Paragraph>
        <Text className='BaseText2'>Antibodies are the most commonly used molecule for lateral flow assays; however, aptamers have better stability, an easier synthesis, a wider target potential, a higher affinity and increased modifiability. This eliminates the need of refrigeration for storage, extends the shelf life, reduces the production costs, reduces batch-to-batch variability and shortens the generation time [26, 27]. In the context of modularity for the synthetic biology community, aptamers have a higher compatibility with diverse formats and platforms and they can be selected for virtually any target [28]. Because of this, they are becoming the future of diagnostics and these features make them ideal diagnostic candidates for our biosensor.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '70%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-description/9-tabla.png'/>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Siete;
